import React from 'react';
import './OrderDetail.scss';
import { t } from 'localization';
import { Block } from 'components/Block';

export const OrderDetail = (props) => {
  const { data } = props;
  const { code, customer_note: customerNote, item_info: itemInfo = {} } = data;
  const { parcel_images: parcelImages = [] } = itemInfo;
  const listImages = [];
  parcelImages.forEach((item) => {
    item.forEach((itemImage) => {
      listImages.push(itemImage.value);
    });
  });
  return (
    <Block title={t('order-detail')} desc={[[`${t('order-id')}: `, code]]} line>
      <div className='order-detail'>
        <div className='customer-note'>
          <span className='note-header'>{`${t('order-detail-note')}: `}</span>
          <span className='note'>{customerNote || '-'}</span>
        </div>
        <div className='parcel-image'>
          {listImages.map((item, index) => (
            <img
              key={index}
              className='parcel-image-item'
              src={item}
              alt='parcel-note'
            />
          ))}
        </div>
      </div>

    </Block>
  );
};
